// =============================================================================
// Cloudinary delivery urls. Kept free of zod and server code: the Image
// component imports it on every page.
// =============================================================================

export function isCloudinaryUrl(url: string): boolean {
  return url.startsWith("https://res.cloudinary.com/");
}

// =============================================================================
